function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHourglass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 25,
    viewBox: "0 0 24 25",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 7.341V4a1.502 1.502 0 00-1.5-1.5H6.75A1.502 1.502 0 005.25 4v3.375a1.508 1.508 0 00.6 1.2l4.9 3.675-4.9 3.675a1.507 1.507 0 00-.6 1.2V20.5a1.502 1.502 0 001.5 1.5h10.5a1.502 1.502 0 001.5-1.5v-3.341a1.503 1.503 0 00-.596-1.197l-4.91-3.712 4.91-3.712a1.505 1.505 0 00.596-1.197z",
    fill: props.fill
  }));
}

export default SvgHourglass;